import React, { useState } from "react";
import styles from "./leave-detail-modal.module.css";
import { capitalizeFirstLetter } from "../../../../utils/format-text/fomat-text";
import { Modal, Typography } from "antd";
import SVGIcon from "../../../../constants/SVGIcon";
import StatusChip from "../../../../components/status-chip/status-chip";
import moment from "moment";
import CustomButton from "../../../../common/custom-button/custom-button";
import { leaveAction } from "../../../../services/holiday_leave";
import { toast } from "react-toastify";

const LeaveDetailModal = ({ detailsData, modalOpen, modalClose }) => {
  const [loading, setLoading] = useState(false);

  const handleLeaveReject = (id) => {
    handleLeaveAction(id, "Rejected");
  };

  const handleLeaveApprove = async (id) => {
    handleLeaveAction(id, "Approved");
  };

  const handleLeaveAction = async (id, status) => {
    try {
      setLoading(true);
      const resp = await leaveAction(id, status);
      const data = resp?.data;

      toast.success(data?.message);
      setLoading(false);
      modalClose();
    } catch (err) {
      setLoading(false);
      toast.error("Error Retrieving Stats");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onCancel={() => modalClose()}
        footer={null}
        title={<div className={styles.title}>Leave Detail</div>}
        width={500}
      >
        <div className={styles.modal_card}>
          {detailsData && (
            <div>
              <div className={styles.card_header}>
                <div className={styles.header_left}>
                  <span className={styles.icon_bg}>
                    <SVGIcon
                      name="users-blue-icon"
                      width="16"
                      height="16"
                      className="anticon"
                      stroke="#0085FF"
                    />
                  </span>
                  <Typography className={styles.card_title}>
                    {detailsData?.leave_type}
                  </Typography>
                </div>
                <StatusChip
                  status={
                    detailsData?.status === "Pending"
                      ? "action required"
                      : detailsData?.status
                  }
                />
              </div>
              <div className={styles.below_card}>
                <div className={styles.row}>
                  <span className={styles.label}>Department:</span>
                  <span className={styles.sub_label}>
                    {capitalizeFirstLetter(detailsData?.leave_type)}
                  </span>
                </div>
                <div className={styles.row}>
                  <SVGIcon
                    name="calendar-icon"
                    width="22"
                    height="22"
                    className="anticon"
                  />
                  <span className={styles.date_title}>Leave Duration:</span>
                  <span className={styles.date_title}>
                    {moment(detailsData?.start_date).format("Do MMMM, YYYY")} -{" "}
                    {moment(detailsData?.end_date).format("Do MMMM, YYYY")} (
                    {detailsData?.leave_duration} day)
                  </span>
                </div>
                <div className={styles.row}>
                  <SVGIcon
                    name="calendar-icon"
                    width="22"
                    height="22"
                    className="anticon"
                  />
                  <span className={styles.date_title}>Applied On:</span>
                  <span className={styles.date_title}>
                    {moment(detailsData?.applied_on).format("Do MMMM, YYYY")}
                  </span>
                </div>
                {detailsData?.details && (
                  <div className={styles.row}>
                    <span>{capitalizeFirstLetter(detailsData?.details)}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {detailsData?.status === "Pending" ? (
          <div style={{ display: "flex", marginTop: "14px", gap: "10px" }}>
            <CustomButton
              title="Reject"
              size="large"
              style={{
                width: "50%",
                height: "40px",
                backgroundColor: "#fff",
                color: "#4A4A4A",
              }}
              onClick={() => handleLeaveReject(detailsData?.id)}
            />
            <CustomButton
              title="Approve"
              size="large"
              style={{ width: "50%", height: "40px" }}
              onClick={() => handleLeaveApprove(detailsData?.id)}
            />
          </div>
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
};

export default LeaveDetailModal;
